module.exports = __webpack_public_path__ + "static/img/icon_10.efbec50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_10.png
// module id = Vsh5
// module chunks = 0